import { useEffect, useState } from "react";

const QUERY = "(max-width: 639px)";

/** true onder het sm-breekpunt (zelfde grens als Tailwind `sm:`). */
export const useMobiel = () => {
  const [mobiel, setMobiel] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const f = (e) => setMobiel(e.matches);
    mq.addEventListener("change", f);
    return () => mq.removeEventListener("change", f);
  }, []);
  return mobiel;
};
